import { useEffect, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { ArrowLeft, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { EmployeeForm } from "@/components/EmployeeForm";

export default function EmployeeNew() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const readOnly = user?.role === "viewer";
  const [banks, setBanks] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/banks").then((r) => setBanks(r.data || [])).catch(() => {});
    api.get("/employees").then((r) => setEmployees(r.data || [])).catch(() => {});
  }, []);

  const submit = async (payload, fingerspotPin, photoFile) => {
    setBusy(true);
    try {
      const { data } = await api.post("/employees", payload);
      if (isAdmin && data?.id && fingerspotPin) {
        try { await api.put(`/employees/${data.id}/fingerspot-pin`, { pin: fingerspotPin }); }
        catch (fe) { toast.error(errMsg(fe)); }
      }
      if (data?.id && photoFile) {
        try {
          const fd = new FormData();
          fd.append("file", photoFile);
          await api.post(`/employees/${data.id}/photo`, fd, { headers: { "Content-Type": "multipart/form-data" } });
        } catch (pe) { toast.error("Karyawan dibuat, tapi foto gagal diupload: " + errMsg(pe)); }
      }
      toast.success("Karyawan ditambahkan");
      navigate(`/employees/${data.id}`);
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };

  return (
    <div data-testid="employee-new" className="space-y-5">
      {readOnly && <Navigate to="/karyawan" replace />}
      <button data-testid="emp-new-back" onClick={() => navigate("/karyawan")} className="flex items-center gap-1.5 text-[13.5px] font-medium text-[#8E8E93] transition-colors hover:text-[#1D1D1F]">
        <ArrowLeft className="h-4 w-4" /> Employees
      </button>

      {/* Hero header */}
      <div className="flex items-center gap-3.5 rounded-[20px] border border-white/60 bg-gradient-to-br from-[#EEF3FA] to-[#F7F4FB] p-4 shadow-[0_10px_40px_rgba(0,0,0,0.05)] sm:gap-4 sm:p-5">
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-[#0071E3] text-white shadow-[0_8px_20px_rgba(0,113,227,0.3)] sm:h-14 sm:w-14">
          <UserPlus className="h-6 w-6 sm:h-7 sm:w-7" />
        </span>
        <div className="min-w-0">
          <p className="text-[10.5px] font-semibold uppercase tracking-wider text-[#0071E3] sm:text-[11px]">Tambah Karyawan</p>
          <h1 className="text-[19px] font-semibold tracking-tight sm:text-[26px]">Karyawan Baru</h1>
          <p className="mt-0.5 text-[12px] text-[#6E6E73] sm:text-[12.5px]">Pilih tipe, isi data, lalu simpan untuk membuat profil.</p>
        </div>
      </div>

      <div className="card-soft p-4 sm:p-6 lg:p-8">
        <EmployeeForm isNew isAdmin={isAdmin} banks={banks} employees={employees} busy={busy} onSubmit={submit} onCancel={() => navigate("/karyawan")} />
      </div>
    </div>
  );
}
